const pl = {
    header: {
        products: 'Produkty',
        about: 'O nas',
        contact: 'Kontakt',
        cart: 'Koszyk',
        transactionList: 'Lista transakcji',
        manageProducts: 'Zarządzaj produktami',
        manageCategories: 'Zarządzaj kategoriami',
        changePassword: 'Zmień hasło',
    },
    cart: {
        title: 'w koszyku',
        order: 'Zamów',
        item: 'przedmiot',
        items_2_4: 'przedmioty',
        items_5plus: 'przedmiotów',
    },
    home: {
        subtitle: 'Profesjonalne aluminiowe rozwiązania dla ogrodów, oświetlenia i architektury krajobrazu.',
        button: 'Zobacz więcej',
        listTitle: 'Lista ofert',
    },
    footer: {
        terms: 'Regulamin',
        returnPolicy: 'Zasady zwrotów i reklamacji',
    },
    contact: {
        title: 'Skontaktuj się z nami',
        subtitle: 'Jesteśmy tu, aby odpowiedzieć na wszystkie Twoje pytania',
        callUs: 'Zadzwoń do nas',
        callDesc: 'Jeśli potrzebujesz natychmiastowej pomocy lub chcesz porozmawiać z nami, jesteśmy dostępni od poniedziałku do piątku.',
        writeUs: 'Napisz do nas',
        writeDesc: 'Masz pytania lub potrzebujesz pomocy? Skontaktuj się z nami przez e-mail, a odpowiemy najszybciej jak to możliwe.',
        hours: 'Godziny otwarcia',
        weekdays: 'Poniedziałek - Piątek',
        address: 'Adres',
        readyTitle: 'Gotowy do współpracy?',
        readyText: 'Niezależnie od tego, czy masz pytania o nasze produkty, potrzebujesz pomocy z zamówieniem, czy po prostu chcesz porozmawiać - jesteśmy tutaj dla Ciebie.',
        callNow: 'Zadzwoń teraz',
        sendEmail: 'Wyślij e-mail',
        formTitle: 'Wyślij wiadomość',
        formSubtitle: 'Wypełnij formularz, a odpowiemy najszybciej jak to możliwe',
        formName: 'Imię i nazwisko',
        formNamePlaceholder: 'Jan Kowalski',
        formEmail: 'Adres e-mail',
        formEmailPlaceholder: 'jan@przykład.pl',
        formPhone: 'Telefon (opcjonalnie)',
        formPhonePlaceholder: '+48 500 000 000',
        formSubject: 'Temat',
        formSubjectPlaceholder: 'Zapytanie o produkt',
        formMessage: 'Wiadomość',
        formMessagePlaceholder: 'Opisz swoje pytanie lub zapytanie...',
        formSubmit: 'Wyślij wiadomość',
        formSending: 'Wysyłanie...',
        formSuccess: 'Wiadomość wysłana! Odpowiemy najszybciej jak to możliwe.',
        formError: 'Nie udało się wysłać wiadomości. Spróbuj ponownie lub skontaktuj się bezpośrednio.',
        formErrorRequired: 'To pole jest wymagane',
        formErrorEmail: 'Podaj poprawny adres e-mail',
    },
    aboutUs: {
        title: 'O nas',
        subtitle: 'Tworzymy aluminiową małą architekturę krajobrazu od ponad 3 lat',
        whatWeDoTitle: 'Czym się zajmujemy?',
        whatWeDoDesc: 'Jesteśmy producentem aluminiowych elementów małej architektury krajobrazu, oferujących rozwiązania najwyższej jakości dla różnorodnych potrzeb naszych klientów.',
        mastsTitle: 'Maszty',
        mastsDesc: 'Do kamer i oświetlenia',
        lampsTitle: 'Lampy ogrodowe',
        lampsDesc: 'Nowoczesne oświetlenie LED',
        lamelTitle: 'Lamele elewacyjne',
        lamelDesc: 'Estetyczne wykończenia',
        pergolasTitle: 'Pergole i trejaże',
        pergolasDesc: 'Kraty ogrodowe',
        constructionsTitle: 'Konstrukcje',
        constructionsDesc: 'Tarasy i zadaszenia',
        yearsLabel: 'Lat doświadczenia',
        alumLabel: 'Aluminium',
        possLabel: 'Możliwości',
        missionTitle: 'Nasza misja',
        missionText: 'Nasze produkty można spotkać nie tylko u prywatnych klientów, lecz również w szkołach, urzędach czy galeriach handlowych. Nieustannie rozszerzamy wachlarz naszych usług i wprowadzamy nowe rozwiązania, dbając o najwyższą jakość wykonania.',
    },
    product: {
        categories: 'Kategorie',
        height: 'Wysokość',
        price: 'Cena',
        quantity: 'Ilość',
        addToCart: 'Dodaj do koszyka',
        shipping: 'wysyłka',
        perPiece: '/szt',
        imageUnavailable: 'Podgląd oferty chwilowo niedostępny',
        previewUnavailable: 'Podgląd oferty obecnie niedostępny',
        from: 'od',
        warning: 'Uwaga',
        downloads: 'Do pobrania',
        declarationOfConformity: 'Deklaracja zgodności',
        declarationOfConformityDesc: 'Dokument potwierdzający zgodność produktu z normami UE',
        productCard: 'Karta produktu',
        productCardDesc: 'Szczegółowa specyfikacja techniczna produktu',
        download: 'Pobierz',
        attention: [
            'Prace związane z podłączeniem elektrycznym powinny być wykonywane przez specjalistę z odpowiednimi uprawnieniami',
            'Poprawnie zamontowane urządzenie można podłączyć jedynie do sprawnej instalacji elektrycznej.',
            'Nie wolno montować urządzenia z widocznymi uszkodzeniami obudowy lub przewodu zasilającego',
            'Produkt przeznaczony jest do montażu na zewnątrz budynków.',
            'Przed przystąpieniem do montażu należy odłączyć zasilanie oraz zachować zasady BHP.',
        ],
        labels: [
            {
                src: 'https://dl37p4knu94gw.cloudfront.net/Śmietnik.png',
                text: 'Sprzęt elektryczny oznaczony symbolem przekreślonego kosza nie może być wyrzucony łącznie z odpadami komunalnymi. Taki sprzęt podlega zbiórce i recyklingowi.',
            },
            {
                src: 'https://dl37p4knu94gw.cloudfront.net/Uziemienie.png',
                text: 'Urządzenie z przewodem ochronnym. Niebieski - N; Brązowy – L; Żółto-zielony – uziemienie',
            },
            {
                src: 'https://dl37p4knu94gw.cloudfront.net/cece.png',
                text: 'Spełnia wymagania dyrektyw Nowego Podejścia Unii Europejskiej.',
            },
        ],
    },
    categories: {
        breadcrumb: 'Kategorie',
        currentOffers: 'Obecnie dostępne oferty',
    },
    checkout: {
        title: 'Zamówienie',
        shippingSection: 'Dane do wysyłki',
        billSection: 'Dane do faktury',
        orderSummary: 'Twoje zamówienie',
        firstName: 'Imię',
        lastName: 'Nazwisko',
        email: 'E-mail',
        phone: 'Telefon',
        address: 'Adres',
        city: 'Miasto',
        postalCode: 'Kod pocztowy',
        country: 'Kraj',
        notes: 'Uwagi do zamówienia',
        wantInvoice: 'Chcę otrzymać fakturę VAT',
        cod: 'Płatność za pobraniem',
        codBlocked: 'Płatność za pobraniem jest niedostępna dla produktów o wysokości 5m lub więcej.',
        companyName: 'Nazwa firmy',
        fullAddress: 'Pełny adres',
        submit: 'Złóż zamówienie',
        submitOrder: 'Zamawiam i płacę',
        summary: 'Podsumowanie',
        total: 'Razem',
        shipping: 'Wysyłka',
        shippingCost: 'Koszt wysyłki',
        quantity: 'Ilość',
        errors: {
            nameRequired: 'Imię jest wymagane',
            surnameRequired: 'Nazwisko jest wymagane',
            emailRequired: 'Email jest wymagany',
            emailInvalid: 'Email jest niepoprawny',
            phoneRequired: 'Numer telefonu jest wymagany',
            phoneInvalid: 'Format numeru telefonu jest niepoprawny',
            addressRequired: 'Adres jest wymagany',
            cityRequired: 'Miasto jest wymagane',
            zipRequired: 'Kod pocztowy jest wymagany',
            zipInvalid: 'Kod pocztowy jest niepoprawny',
            companyRequired: 'Nazwa firmy jest wymagana',
            nipRequired: 'NIP jest wymagany',
            nipInvalid: 'NIP jest niepoprawny',
        },
    },
    success: {
        title: 'Dziękujemy za zakupy!',
        subtitle: 'Zamówienie zostało złożone i opłacone. Potwierdzenie zamówienia oraz szczegóły zostały przesłane drogą mailową. Jeżeli mail nie doszedł do Państwa, prosimy o sprawdzenie folderu spam. Pozdrawiamy, Expo Aluminium.',
    },
    cancel: {
        title: 'Zamówienie zostało anulowane.',
        subtitle: 'Anulowałeś zamówienie lub wystąpił błąd podczas płatności.',
        shopLinkText: 'Jeśli chcesz złożyć zamówienie ponownie, przejdź do',
        shopLink: 'sklepu',
    },
    notFound: {
        title: 'Nie znaleziono strony',
        subtitle: 'Przepraszamy, taka strona nie istnieje',
        home: 'Strona główna',
    },
    common: {
        loading: 'Ładowanie...',
        error: 'Wystąpił błąd',
        back: 'Powrót',
    },
} as const;

type Stringify<T> = {
    [K in keyof T]: T[K] extends string
        ? string
        : T[K] extends readonly string[]
        ? readonly string[]
        : T[K] extends object
        ? Stringify<T[K]>
        : T[K];
};

export type Translations = Stringify<typeof pl>;
export default pl;
